export default __webpack_public_path__ + "static/media/firebase-logo-standard.f52677e4.svg";